import React from 'react';

class LocationPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,

      filters: {
        region: this.props.region || null,
        province: this.props.province || null,
        city: this.props.city || null
      }
    };

    this.handleSelectRegion = this.handleSelectRegion.bind(this);
    this.handleSelectProvince = this.handleSelectProvince.bind(this);
    this.handleSelectCity = this.handleSelectCity.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  handleSelectRegion(e) {
    const dropdown = e.currentTarget;
    const id = dropdown.value;
    const name = dropdown.options[dropdown.selectedIndex].text;

    this.setState((prevState) => {
      prevState.filters.region = {
        id,
        name
      };
      prevState.filters.province = null;
      prevState.filters.city = null;

      return prevState;
    }, () => {
      this.handleLocationChange();
    });
  }
  handleSelectProvince(e) {
    const dropdown = e.currentTarget;
    const id = dropdown.value;
    const name = dropdown.options[dropdown.selectedIndex].text;

    this.setState((prevState) => {
      prevState.filters.province = {
        id,
        name
      };
      prevState.filters.city = null;

      return prevState;
    }, () => {
      this.handleLocationChange();
    });
  }
  handleSelectCity(e) {
    const dropdown = e.currentTarget;
    const id = dropdown.value;
    const name = dropdown.options[dropdown.selectedIndex].text;

    this.setState((prevState) => {
      prevState.filters.city = {
        id,
        name
      };

      return prevState;
    }, () => {
      this.handleLocationChange();
    });
  }

  handleLocationChange() {
    if (this.props.onChange) {
      this.props.onChange(this.state.filters.region, this.state.filters.province, this.state.filters.city);
    }
  }

  render() {
    const isActive = this.state.hover || this.state.filters.region || this.state.filters.province || this.state.filters.city;

    const pickerStyle = !isActive ? {
      opacity: 0.5
    } : {opacity: 1};

    const iconStyle = {
      fontSize: '15px',
    };
    const dropdownStyle = {
      width: '30%'
    };

    return (
      <div style={pickerStyle} onMouseOver={(e) => {this.setState({hover: true})}} onMouseOut={(e) => {this.setState({hover: false})}}>
        <table border="0" width="100%">
          <tbody>
            <tr>
              <td>
                <form className="form-inline">
                  <select className="form-control mr-3" style={dropdownStyle} onChange={this.handleSelectRegion} value={this.state.filters.region ? this.state.filters.region.id : ''}>
                    <option value="">Tutte le regioni</option>
                    {
                      this.props.appData.cache.locationsByType.region.map((region) => {
                        return <option value={region.id}>{region.name}</option>;
                      })
                    }
                  </select>
                  <select className="form-control mr-3" style={dropdownStyle} value={this.state.filters.province ? this.state.filters.province.id : ''} disabled={!this.state.filters.region ? 'disabled' : ''} onChange={this.handleSelectProvince}>
                    <option value="">Tutte le province</option>
                    {
                      this.props.appData.cache.locationsByType.province.map((province) => {
                        if (!this.state.filters.region || this.state.filters.region.id == province.region.id) {
                          return <option value={province.id}>{province.name}</option>;
                        }
                      })
                    }
                  </select>
                  <select className="form-control" style={dropdownStyle} value={this.state.filters.city ? this.state.filters.city.id : ''} disabled={!this.state.filters.province ? 'disabled' : ''} onChange={this.handleSelectCity} >
                    <option value="">Tutte le citt&agrave;</option>
                    {
                      this.props.appData.cache.locationsByType.city.map((city) => {
                        if (!this.state.filters.province || this.state.filters.province.id == city.province.id) {
                          return <option value={city.id}>{city.name}</option>;
                        }
                      })
                    }
                  </select>
                </form>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default LocationPicker;


// WEBPACK FOOTER //
// ./src/components/shared/LocationPicker.js